import { defineComponent, h, ref, useAttrs } from 'vue'
import { VCombobox } from 'vuetify/components'
import {
  normalizeLegacyMenuProps,
  resolveBgColor,
  resolveDensity,
  resolveVariant,
  stripLegacyInputAttrs,
  withLegacyDirtyClass
} from './legacyInputProps'

VCombobox.compatConfig = {
  ...(VCombobox.compatConfig || {}),
  COMPONENT_V_MODEL: false,
  INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning'
}

function normalizeItems(items) {
  if (!Array.isArray(items)) return items
  return items.map((item) => {
    if (item == null || typeof item !== 'object' || Array.isArray(item)) {
      return item
    }

    return {
      ...item,
      title: item.title ?? item.text ?? item.label ?? item.value,
      value: item.value ?? item.key ?? item.id
    }
  })
}

function stripLegacyAttrs(attrs) {
  const normalized = stripLegacyInputAttrs(attrs)
  const menuProps = normalizeLegacyMenuProps(attrs)

  if (menuProps) {
    normalized.menuProps = menuProps
  }

  delete normalized.value
  delete normalized.itemText
  delete normalized['item-text']
  delete normalized.itemValue
  delete normalized['item-value']
  delete normalized['menu-props']
  return normalized
}

export default defineComponent({
  name: 'VComboboxCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input', 'change'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()
    let lastExternalValue
    const localValue = ref()

    return () => {
      const variant = resolveVariant(attrs)
      const density = resolveDensity(attrs)
      const bgColor = resolveBgColor(attrs)
      const externalValue = attrs.modelValue ?? attrs.value
      if (lastExternalValue !== externalValue) {
        lastExternalValue = externalValue
        localValue.value = externalValue
      } else if (localValue.value === undefined) {
        localValue.value = externalValue
      }

      return h(
        VCombobox,
        {
          ...withLegacyDirtyClass(stripLegacyAttrs(attrs), attrs),
          ...(variant ? { variant } : {}),
          ...(density ? { density } : {}),
          ...(bgColor ? { bgColor } : {}),
          items: normalizeItems(attrs.items),
          modelValue: localValue.value,
          'onUpdate:modelValue': (value) => {
            if (value === localValue.value) return
            localValue.value = value
            emit('update:modelValue', value)
            emit('input', value)
            emit('change', value)
          }
        },
        slots
      )
    }
  }
})
